export default {
  default: ['(##) ####-####', '(##) #####-####'],
  token: { '#': { pattern: /\d/ } }
};
